import { bridgelessRpcApiClient } from '@/api/clients'

interface ChainState {
  last_block_height: string
  last_block_app_hash: string
}

interface StatusResponse {
  result: {
    sync_info: {
      latest_block_height: string
      latest_app_hash: string
    }
  }
}

export async function fetchChainState(): Promise<ChainState> {
  const { data } = await bridgelessRpcApiClient.get<StatusResponse>('/status')

  return {
    last_block_height: data.result.sync_info.latest_block_height,
    last_block_app_hash: data.result.sync_info.latest_app_hash,
  }
}
